// The nine tools in the brand backdrop: pen paths, code and interface pieces.
export const toolNames = ["pen-nib", "bezier-arc", "anchor-handles", "code-tag", "code-braces", "code-arrow", "cursor", "selection-box", "toggle"]
